import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

const TIMEZONE = undefined;
const LOCALE = 'ja-JP';

/**
 * Sample use: {{ date | sameDateDisplay: dateToCompare : 'HH:mm' : 'yyyy/MM/dd（EEEEE）HH:mm' }}
 */
@Pipe({
    name: 'sameDateDisplay',
})
export class SameDateDisplayPipe implements PipeTransform {
    constructor(
        private datePipe: DatePipe,
    ) { }

    transform(
        value: Date | string,
        dateToCompare: Date | string,
        formatIfTrue: string,
        formatIfFalse: string,
    ): string {
        const isSameDate = this.isSameDateWithoutTime(value, dateToCompare);
        if (isSameDate) {
            const formatTrueUseLocale = this.checkFormatHasCharE(formatIfTrue);
            if (formatTrueUseLocale) {
                return this.datePipe.transform(value, formatIfTrue, TIMEZONE, LOCALE);
            }
            return this.datePipe.transform(value, formatIfTrue);
        }

        const formatFalseUseLocale = this.checkFormatHasCharE(formatIfFalse);
        if (formatFalseUseLocale) {
            return this.datePipe.transform(value, formatIfFalse, TIMEZONE, LOCALE);
        }
        return this.datePipe.transform(value, formatIfFalse);
    }

    private isSameDateWithoutTime(a: Date | string, b: Date | string): boolean {
        const aDate = new Date(new Date(a).setHours(0, 0, 0, 0));
        const bDate = new Date(new Date(b).setHours(0, 0, 0, 0));
        if (
            ((aDate instanceof Date) && !isNaN(aDate.getTime()))
            && ((bDate instanceof Date) && !isNaN(bDate.getTime()))
        ) {
            return aDate.getTime() === bDate.getTime();
        }
        return false;
    }

    /**
     * Check format has character E
     * Example, catch: yyyy/MM/dd（EEEEE）HH:mm
     */
    private checkFormatHasCharE(format: string): boolean {
        return format.toUpperCase().includes('E');
    }
}
